declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SpinnerService } from '../../../../../services/spinner.service';
import { FDService } from '../../../../../services/fd.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FDActorDocRequest, FdActorReportsDocController, FDSectionRequest, FdSectionsController, FDActorReportDetailsDocRequest, FdActorDocReportDetailsController, FdActorDocReportDetailsBySectionCode } from '../../../../../models/formdesign/fd.model';
import { AppData } from '../../../../../models/appdata';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { DBOperation } from '../../../../../enums/enum';
import { NgbActorFormsModal } from '../../modals/actorforms.modal';
import * as $ from 'jquery';
import * as alertFunctions from '../../../../../../shared/data/sweet-alerts';
import { routerTransition } from '../../../../../animations/router.animations';



@Component({
  selector: 'actorformsv2',
  templateUrl: './actorformsv2.component.html',
  styleUrls: ['./actorformsv2.component.scss']
  , animations: [routerTransition()]
})

export class ActorFormsV2Component implements OnInit {

  CurrentFDActorDocRequest: FDActorDocRequest;

  @Input() ActorCode: number;
  @Input() ActorType: number;
  @Input() ReportType: string = "";
  @Input() ResultType: string = "";

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public ActorReportTemplateCode: number = 0;

  public IsShowActorFormList: boolean =true;
  public IsRateing: boolean = false;

  CurrentFdActorReportsDocController: FdActorReportsDocController[];

  public ActorReportCode: number = 0;
  public SectionCode: number = 0;
  public TemplateName: string;
  public SectionName: string;

  //
  CurrentFDSectionRequest: FDSectionRequest;
  CurrentFdSectionsController: FdSectionsController[];

  //
  CurrentFDActorReportDetailsDocRequest: FDActorReportDetailsDocRequest;
  CurrentFdActorDocReportDetailsController: FdActorDocReportDetailsController[];
  CurrentFdActorDocReportDetailsBySectionCode: FdActorDocReportDetailsBySectionCode;


  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService, private fdservice: FDService,
    private modalService: NgbModal) { }


  ngOnInit() {
    $.getScript('./healins-assets/js/jquery.steps.js');
    $.getScript('./healins-assets/js/profilesteps.js');
    this.CurrentFDActorDocRequest = new FDActorDocRequest();
    this.CurrentFDActorDocRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    if (this.ActorCode > 0) {
      this.CurrentFDActorDocRequest.ActorCode = this.ActorCode;
    }
    else {
      this.CurrentFDActorDocRequest.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    }
    if (this.ReportType === "")
    {
      if (AppData.Instance().UserLoginDetails.UserType = 3) {
        this.ReportType ="Nurse"
      }
      else if (AppData.Instance().UserLoginDetails.UserType = 13) {
        this.ReportType = "Registry"
      }
      else if (AppData.Instance().UserLoginDetails.UserType = 14) {
        this.ReportType = "Registry"
      }
    }
    if (this.ResultType === "") {
      this.ResultType ="Rateing"
    }
   
    
    this.CurrentFDActorDocRequest.CreatedUserName = AppData.Instance().UserLoginDetails.UserName;

    this.CurrentFdActorReportsDocController = new Array<FdActorReportsDocController>();



    this.CurrentFDSectionRequest = new FDSectionRequest();
    this.CurrentFDSectionRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentFdSectionsController = new Array<FdSectionsController>();


//
    this.CurrentFdActorDocReportDetailsController = new Array<FdActorDocReportDetailsController>();


    this.CurrentFDActorReportDetailsDocRequest = new FDActorReportDetailsDocRequest();
    this.CurrentFDActorReportDetailsDocRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentFDActorReportDetailsDocRequest.FdActorDocReportDetailsController = new Array<FdActorDocReportDetailsController>();
    //
    this.CurrentFdActorDocReportDetailsBySectionCode = new FdActorDocReportDetailsBySectionCode();
    this.CurrentFdActorDocReportDetailsBySectionCode.SendApiRequestModel = AppData.Instance().ApiRequestParms;

//
    this.GetFdActorReportsDocController();



  }
  ShowActorFormList() {
    if (this.IsShowActorFormList === true) {
      this.IsShowActorFormList = false;

    }
    else {
      this.IsShowActorFormList = true;
    }
 
  }

  GetFdActorReportsDocController() {
    this.StartRefreshing();
    this.fdservice.GetFdActorReportsDocController(this.CurrentFDActorDocRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentFdActorReportsDocController = this.ApiResData.Result;
          this.SectionCode = 0;

          this.initGridButton();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }



  GetFdActorReportsDocControllerWithOutSectionRefresh() {
    this.StartRefreshing();
    this.fdservice.GetFdActorReportsDocController(this.CurrentFDActorDocRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentFdActorReportsDocController = this.ApiResData.Result;
          //this.SectionCode = 0;

          //this.initGridButton();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }
  onChangeTemplate(Event: any) {
    console.log('-----onChangeActorReportCode-------->' + Event)
    this.SectionCode = 0;
    this.ActorReportCode = parseInt(Event);
    //
    var CurrentFdActorReportsDocControllerByCode = this.CurrentFdActorReportsDocController.filter(x => x.ActorReportCode === parseInt(Event));
    if (CurrentFdActorReportsDocControllerByCode.length > 0) {
      this.CurrentFDSectionRequest.BodyCode = CurrentFdActorReportsDocControllerByCode[0].TemplateBodyCode;
      this.TemplateName = CurrentFdActorReportsDocControllerByCode[0].TemplateName;
      if (CurrentFdActorReportsDocControllerByCode[0].ResultType === this.ResultType) {
        //"Rateing"
        this.IsRateing = true;
      }
      else {
        this.IsRateing = false;
      }
     
      this.GetFdSectionsController();
    

    }
    else {
      this.CurrentFDSectionRequest.BodyCode = 0;
      this.GetFdSectionsController();
      //alertFunctions.AlertParam('Sections Not Exits....!');
    }


  }
  onChangeSectionCode(Event: any) {
    console.log('-----onChangeSectionCode-------->' + Event)
    this.SectionCode = parseInt(Event);
    var CurrentFdSectionsControllerByCode = this.CurrentFdSectionsController.filter(x => x.SectionCode === parseInt(Event));
    if (CurrentFdSectionsControllerByCode.length > 0) {
      this.SectionName = CurrentFdSectionsControllerByCode[0].SectionTitle;
    }
    if (this.SectionCode > 0 && this.ActorReportCode > 0) {
      this.CurrentFdActorDocReportDetailsBySectionCode.SectionCode = this.SectionCode;
      this.CurrentFdActorDocReportDetailsBySectionCode.ActorReportCode = this.ActorReportCode;
      this.GetFdActorDocReportDetailsBySectionCodeController();
    }
    //
 




  }
  GetFdActorDocReportDetailsBySectionCodeController() {
    this.StartRefreshing();
    this.fdservice.GetFdActorDocReportDetailsBySectionCodeController(this.CurrentFdActorDocReportDetailsBySectionCode)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //CurrentFdActorDocReportDetailsController and CurrentFdActorDocReportDetailsBySectionCodeController Both are Same

          this.CurrentFdActorDocReportDetailsController = this.ApiResData.Result;

          //  console.log('CurrentFdActorDocReportDetailsController--->' + this.CurrentFdActorDocReportDetailsController[0].CanShowTitle);


          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }


  public SaveFDActorDocReportDetails() {
    this.CurrentFDActorReportDetailsDocRequest.FdActorDocReportDetailsController = this.CurrentFdActorDocReportDetailsController;
    this.fdservice.SaveFDActorDocReportDetails(this.CurrentFDActorReportDetailsDocRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            this.GetFdActorReportsDocControllerWithOutSectionRefresh();

            alertFunctions.ShowSuccess('Success', 'Save operation completed successfully.');


            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }
  GetFdSectionsController() {
    this.StartRefreshing();
    this.fdservice.GetFdSectionsController(this.CurrentFDSectionRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentFdSectionsController = this.ApiResData.Result;
          this.initGridButton();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }

  //
  //

  public onSubmitTemplate() {
    if (this.ActorReportTemplateCode > 0) {
      this.StartRefreshing();
      this.CurrentFDActorDocRequest.ConditionalOperator = 1;
      this.CurrentFDActorDocRequest.ActorReportTemplateCode = this.ActorReportTemplateCode;

      this.fdservice.SaveFdActorReportDoc(this.CurrentFDActorDocRequest)
        .subscribe((result) => {
          this.ApiResData = result;
          if (!this.ApiResData.hasError) {

            if (this.ApiResData.Result > 0) {

              //this.GetFdActorReportsDocController();

              alertFunctions.AlertParam('Saved Successfully.....!');


              this.stopRefreshing();
            }
            else {
              alertFunctions.AlertParam("Invalid Operation...!");


              this.stopRefreshing();

            }

          }
          else {
            this.stopRefreshing();
            if (this.ApiResData.ErrorData != "") {

              alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



            }
            else {
              alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
              //this.activeModal.close();
            }
          }

        },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            // this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            //this.activeModal.close();
            this.stopRefreshing();
          }
        }
        );
    }
    else {
      alertFunctions.AlertParam('Please Select Template Properly...!');
    }
  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }


  //
  isREADONLY: boolean = false;
  exportFileName: string = "FdActorReportForms_";
  dbops: DBOperation;


  columns: any[] = [

    {
      display: 'Certificate',
      variable: 'TemplateName',
      filter: 'text'
    },
    {
      display: 'Applies To',
      variable: 'ReportType',
      filter: 'text'
    },
     {
       display: 'Score',
       variable: 'ResultType',
      filter: 'text'
    }
    
    ,
    {
      display: 'Date',
      variable: 'Date',
      filter: 'date'
    }

  ];
  sorting: any = {
    column: 'Date',
    descending: false
  };
  hdrbtns: any[] = [];
  gridbtns: any[] = [];
  initGridButton() {

    this.hdrbtns = [
      {
        title: 'Add',
        keys: [''],
        action: DBOperation.create,
        ishide: false

      }];

    this.gridbtns = [
      {
        title: 'Remove',
        keys: ["ActorReportCode"],
        action: DBOperation.delete,
        ishide: false
      },


    ];

  }
  //Grid Vars end
  gridaction(gridaction: any): void {

    switch (gridaction.action) {

      case DBOperation.create:
        // alertFunctions.AlertParam('add')
        this.openNewContent();

        break;

      case DBOperation.delete:
        swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#0CC27E',
          cancelButtonColor: '#FF586B',
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, cancel!',
          confirmButtonClass: 'btn btn-success btn-raised mr-5',
          cancelButtonClass: 'btn btn-danger btn-raised',
          buttonsStyling: false
        }).then(() => {



          this.DeleteActorFormByCode(gridaction.values[0].value);

        }, function (dismiss) {
          // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
          if (dismiss === 'cancel') {
            swal(
              'Cancelled',
              'Delete Operation Cancelled :)',
              'error'
            )
          }
        })


        break;

       
    }
  }
  del_(ActorReportCode: any) {

    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorFormByCode(ActorReportCode);

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }

  //
  DeleteActorFormByCode(ActorReportCode: any) {


    console.log('..................');
    this.StartRefreshing();
    this.CurrentFDActorDocRequest.ConditionalOperator = 3;
    this.CurrentFDActorDocRequest.ActorReportCode = ActorReportCode;
    this.fdservice.SaveFdActorReportDoc(this.CurrentFDActorDocRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

          ;
            alertFunctions.AlertParam('Delete Successfully.....!');


            this.stopRefreshing();
            this.GetFdActorReportsDocController();
          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }
  //
  openNewContent() {
    const modalRef = this.modalService.open(NgbActorFormsModal)
    modalRef.componentInstance.ReportType = this.ReportType;
    modalRef.result.then(x => { this.GetFdActorReportsDocController() })

  }

}
